import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  SwipeableDrawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Switch,
  Box,
  useTheme,
} from "@material-ui/core";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ReceiptIcon from "@material-ui/icons/Receipt";
import LockIcon from "@material-ui/icons/Lock";
import ExitIcon from "@material-ui/icons/ExitToApp";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import Brightness4Icon from "@material-ui/icons/Brightness4";

import { selectDrawerOpenStatus, toggleDrawerOpen } from "./navSlice";
import { logout, selectUser } from "../../Auth/userSlice";
import { useNavStyles } from "./navStyles";
import { useAppDispatch } from "../../app/store";
import { useThemeMode } from "../../app/ThemeContext";

const MenuDrawer = () => {
  const drawerOpen = useSelector(selectDrawerOpenStatus);
  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();
  const { themeMode, toggleTheme } = useThemeMode();
  const theme = useTheme();
  let history = useHistory();
  const classes = useNavStyles({});

  //navigate to
  const handleItemClick = (route: string) => {
    dispatch(toggleDrawerOpen()); //toggle drawer close
    history.push(route);
  };

  return (
    <SwipeableDrawer
      classes={{ paper: classes.paper }}
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.paper,
        },
      }}
      disableBackdropTransition
      anchor="left"
      open={drawerOpen}
      onOpen={() => dispatch(toggleDrawerOpen())}
      onClose={() => dispatch(toggleDrawerOpen())}
      // onBackdropClick={() => dispatch(toggleDrawerOpen())}
    >
      <div className={classes.drawerHeader}>
        <AccountCircleIcon />
        <Typography className={classes.drawerUserName} variant="subtitle2">
          {user.name}
        </Typography>
      </div>

      <List>
        <ListItem button></ListItem>
        <ListItem button onClick={() => handleItemClick("/customer")}>
          <ListItemIcon>
            <ReceiptIcon />
          </ListItemIcon>
          <ListItemText>Tositteet</ListItemText>
        </ListItem>
        <ListItem button onClick={() => window.open("https://mst-yhtiot.fi/tietosuojaseloste/", "_blank")}>
          <ListItemIcon>
            <LockIcon />
          </ListItemIcon>
          <ListItemText>Tietosuojaseloste</ListItemText>
        </ListItem>
        <ListItem button>
          <ListItemText></ListItemText>
        </ListItem>
      </List>
      <div className={classes.drawerFooter} style={{ marginBottom: 16 }}>
        <ListItem>
          <Box display="flex" alignItems="center" justifyContent="center" width="100%">
            <Brightness7Icon style={{ marginRight: 8 }} />
            <Switch
              checked={themeMode === "dark"}
              onChange={toggleTheme}
              color="primary"
            />
            <Brightness4Icon style={{ marginLeft: 8 }} />
          </Box>
        </ListItem>
        <ListItem style={{ marginTop: 16 }}>
          <Box 
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            width="100%"
            onClick={() =>
              dispatch(logout()).then((response: any) => history.push("/login"))
            }
            style={{ cursor: "pointer" }}
          >
            <ExitIcon style={{ marginRight: 8 }} />
            <Typography>Kirjaudu ulos</Typography>
          </Box>
        </ListItem>
      </div>
    </SwipeableDrawer>
  );
};
export default MenuDrawer;
